// Component: DeploymentSparkline.jsx
// Purpose: Last-30-minute price sparkline for one deployment, rendered beside LivePriceBadge in
//          the strategy deep-dive header — the ONE place price, change and trend are shown
//          (DX review 2026-10-22: the per-side "Mark" line + sparkline inside the Monitoring trees
//          were deleted). Same instrument-resolution rule as useDeploymentLtp: resolved_* first,
//          frozen id as fallback, so a rolled continuous strategy never charts the wrong contract.

import React from 'react';
import { useDeploymentLtp } from '../../contexts/TradingDataContext';
import { usePriceSparkline } from '../../hooks/trading/usePriceSparkline';
import PriceSparkline from './PriceSparkline';

/**
 * @param {{ deployment: object|null }} props
 */
const DeploymentSparkline = ({ deployment }) => {
  //* Context usage — live tick for the deployment (null until the first tick / when not deployed)
  const tick = useDeploymentLtp(deployment?.deployment_id);
  const points = usePriceSparkline(
    deployment?.resolved_instrument_id ?? deployment?.instrument_id,
    tick?.ltp ?? null,
  );
  return <PriceSparkline points={points} />;
};

export default DeploymentSparkline;
